import { getAllAssets } from "./actions";

/* eslint-disable import/no-anonymous-default-export */
export default {
    //Project Module

    createNewProject: {
        url: '/api/v1/project/create-project',
        method: 'POST'
    },
    getAllProject: {
        url: '/api/v1/project/get-all-project',
        storeKey: 'allProjects',
        method: 'GET'
    },
    getAllProjectsList: {
        url: '/api/v1/project/get-all-projects-list',
        method: 'GET'
    },
    getProjectsFromFacility: {
        url: '/api/v1/project/get-projects-from-facility',
        method: 'GET'
    },
    getProjectById: {
        url: '/api/v1/project/get-project',
    },
    updateProject: {
        url: '/api/v1/project/update-project',
        method: 'POST'
    },
    deleteProject: {
        url: '/api/v1/project/delete-project',
        method: 'DELETE'
    },
    userProjectsList: {
        url: '/api/v1/project/get-user-projects',
    },
    createClient: {
        url: '/api/v1/client/create-client',
        method: 'POST'
    },
    getUserClientIntId: {
        url: '/api/v1/client/get-user-client-int-id',
    },
    allClients: {
        url: '/api/v1/client/get-clients'
    },
    allClientsForExport: {
        url: '/api/v1/client/get-clients-for-export',
        method: 'GET'
    },
    getAllClientsForFilter: {
        url: '/api/v1/client/get-all-clients-for-filter',
        method: 'GET',
        storeKey: 'allClientsForFilter'
    },
    getClientById: {
        url: '/api/v1/client/get-client'
    },
    getClientByUniqueId: {
        url: '/api/v1/client/get-client-by-uniqueId'
    },
    updateClient: {
        url: '/api/v1/client/update-client',
        method: 'POST'
    },
    deleteClient: {
        url: '/api/v1/client/delete-client',
        method: 'DELETE'
    },
    saveConsolidateReport: {
        url: '/api/v1/project/save-consolidate-report',
        method: 'POST'
    },
    updateConsolidateReport: {
        url: '/api/v1/project/update-consolidate-report',
        method: 'POST'
    },
    viewGeneratedReport: {
        url: '/api/v1/project/view-generated-report',
        method: 'GET'
    },
    deleteGeneratedReport: {
        url: '/api/v1/project/delete-generated-report',
        method: 'DELETE'
    },
    //Meter Module
    createNewMeter: {
        url: '/api/v1/meter/create-meter',
        method: 'POST'
    },
    getAllMeter: {
        url: '/api/v1/meter/get-all-meter',
        method: 'GET'
    },
    getAllEquipmentMeters: {
        url: '/api/v1/meter/get-all-equipment-meters',
        method: 'GET'
    },
    getMeterById: {
        url: '/api/v1/meter/get-meter',
    },
    getOnlineMonitoringList: {
        url: '/api/v1/meter/get-online-monitoring-list',
        method: 'GET'
    },
    getOnlineMonitoringDetails: {
        url: '/api/v1/meter/get-online-monitoring-details',
        method: 'GET'
    },
    downloadOnlineMtrngList: {
        url: '/api/v1/meter/download-online-monitoring-list',
        method: 'GET'
    },
    updateOnlineMonitoringDetails: {
        url: '/api/v1/meter/update-online-monitoring-details',
        method: 'POST'
    },
    getProjectsFromMid: {
        url: '/api/v1/meter/get-projects-from-mid',
        method: 'GET'
    },
    deleteOnlineMonitoring: {
        url: '/api/v1/meter/delete-online-monitoring',
        method: 'DELETE'
    },
    getMeterByMeterId: {
        url: '/api/v1/meter/get-meter-by-meter-id'
    },
    updateMeter: {
        url: '/api/v1/meter/update-meter',
        method: 'POST'
    },
    deleteMeter: {
        url: '/api/v1/meter/delete-meter',
        method: 'DELETE'
    },
    getWeeklySummaryTabs: {
        url: '/api/v1/meter/get-weekly-summary-tabs',
    },
    getMidsByFacilityId: {
        url: '/api/v1/meter/get-mids-by-facilityId',
        method: 'GET'
    },
    getProjectMeters: {
        url: '/api/v1/meter/get-project-meters'
    },
    getAllMeterCategories: {
        url: '/api/v1/meter/get-all-meter-categories',
        method: 'GET',
    },

    //Facility Module
    createNewFacility: {
        url: '/api/v1/facility/create-facility',
        method: 'POST'
    },

    allFacilities: {
        url: '/api/v1/facility/get-all-facilities',
        method: 'GET',
        storeKey: 'allFacilities'
    },
    getFacilityById: {
        url: '/api/v1/facility/get-facility',
    },
    updateFacility: {
        url: '/api/v1/facility/update-facility',
        method: 'POST'
    },

    deleteFacility: {
        url: '/api/v1/facility/delete-facility',
        method: 'DELETE'
    },
    getAllFacilityStatus: {
        url: '/api/v1/facility/get-all-facility-status',
        method: 'GET',
        storeKey: 'allFacilityStatus'
    },

    createLocation: {
        url: '/api/v1/location/create',
        method: 'POST'
    },
    getClientLocations: {
        url: '/api/v1/location/get-all-location',
        storeKey: 'allLocations'
    },
    getClientLocationById: {
        url: '/api/v1/location/get-location',
        storeKey: 'clientLocations'
    },
    updateLocation: {
        url: '/api/v1/location/update',
        method: 'POST'
    },
    deleteClientLocation: {
        url: '/api/v1/location/delete',
        method: 'DELETE'
    },
    createInvite: {
        url: '/api/v1/invite/create',
        method: 'POST'
    },
    getAllInvite: {
        url: '/api/v1/invite/invited-data'
    },
    getJoinedGreenUsers: {
        url: '/api/v1/invite/joined-invite-data',
        storeKey: 'allGreenUsers'
    },
    getAllClientUsers: {
        url: '/api/v1/invite/client-users'
    },
    deleteInvite: {
        url: '/api/v1/invite/delete',
        method: 'DELETE'
    },
    updateInvite: {
        url: '/api/v1/invite/update',
        method: 'POST'
    },
    updateJoinedUser: {
        url: '/api/v1/invite/update-joined-user',
        method: 'POST'
    },
    deactivateAuthUser: {
        url: '/api/v1/invite/deactivate-auth-user',
        method: 'POST'
    },
    activateAuthUser: {
        url: '/api/v1/invite/activate-auth-user',
        method: 'POST'
    },
    getUserInviteData: {
        url: '/api/v1/invite/user-invited-data'
    },
    getJoinedUserData: {
        url: '/api/v1/invite/joined-user-data'
    },
    getUserInviteById: {
        url: '/api/v1/invite/user'
    },
    getJoinedUserById: {
        url: '/api/v1/invite/joined-userById'
    },
    getInviteStatusByToken: {
        url: '/api/v1/invite/validate-token'
    },
    acceptInvite: {
        url: '/api/v1/invite/accept',
        method: 'POST'
    },
    //Auth
    register: {
        url: '/api/v1/auth/register',
        method: 'POST',
    },

    login: {
        url: '/api/v1/auth/login',
        method: 'POST',
    },

    forgotPassword: {
        url: '/api/v1/auth/forgot-password',
        method: 'POST',
    },

    resetPassword: {
        url: '/api/v1/auth/reset-password',
        method: 'POST',
    },

    tokenValidation: {
        url: '/api/v1/auth/token-validation',
        method: 'GET',
    },
    getSpocUser: {
        url: '/api/v1/invite/spoc'
    },
    resendInvite: {
        url: '/api/v1/invite/resend-invite',
        method: 'POST'
    },
    uploadMedia: {
        url: '/api/v1/client/upload',
        method: 'POST',
    },
    deleteClientMedia: {
        url: '/api/v1/client/delete-client-media',
        method: 'DELETE'
    },
    deleteMedia: {
        url: '/api/v1/client/delete-media',
        method: 'DELETE'
    },
    getInviteByToken: {
        url: '/api/v1/invite/invite-token-status'
    },

    // Report
    allReports: {
        url: '/api/v1/report/get-all-reports',
    },
    deletReport: {
        url: '/api/v1/report/delete-report',
        method: 'DELETE'
    },
    createNewReport: {
        url: '/api/v1/report/create-report',
        method: 'POST'
    },
    updateReport: {
        url: '/api/v1/report/edit-report',
        method: 'POST'
    },
    getReportById: {
        url: '/api/v1/report/get-report',
    },
    getGreenS3Data: {
        url: '/api/v1/report/get-green-s3-data',
        method: 'POST',
    },
    supersetDashboards: {
        url: '/api/v1/report/superset-dashboard-names',
    },
    getDayWiseReport: {
        url: '/api/v1/report/get-day-wise-report',
    },
    getEquipmentStatusRunningHrs: {
        url: '/api/v1/report/get-equipment-status-running-hrs',
    },

    // User Permissions
    getUsersByClientId: {
        url: '/api/v1/user-permission/get-users-by-client-id',
    },

    user: {
        url: '/api/v1/auth/user'
    },
    role: {
        url: '/api/v1/auth/role'
    },

    //Settings
    updateProfile: {
        url: '/api/v1/auth/update-profile',
        method: 'POST'
    },
    changeUserPassword: {
        url: '/api/v1/auth/user-password',
        method: 'PUT'
    },

    //Meter Tags
    getAllMeterTags: {
        url: '/api/v1/meter/get-all-meter-tags',
        method: 'GET',
        storeKey: 'allMeterTags'
    },
    getAllMeterStatus: {
        url: '/api/v1/meter/get-all-meter-status',
        method: 'GET',
        storeKey: 'allMeterStatus'
    },
    primaryContact: {
        url: '/api/v1/client/get-client-primary-contact'
    },
    getMeterCalibration: {
        url: '/api/v1/meter/calibration'
    },
    getMeterCalibrationById: {
        url: '/api/v1/meter/calibration-details'
    },
    updateCalibrationReport: {
        url: '/api/v1/meter/update-calibration-report',
        method: 'POST'
    },
    deleteCalibrationReport: {
        url: '/api/v1/meter/delete-calibration-report',
        method: 'DELETE'
    },
    cloneCalibrationReport: {
        url: '/api/v1/meter/clone-calibration-report',
        method: 'POST'
    },
    deleteCalibrationReportImage: {
        url: '/api/v1/meter/delete-calibration-report-image',
        method: 'DELETE'
    },
    //OpenAI Integration
    getOpenaiResponse: {
        url: '/api/v1/report/get-openai-response',
        method: 'POST',
    },

    getOpenaiResponseForImageUrl: {
        url: '/api/v1/report/get-openai-response-for-imageurl',
        method: 'POST',
    },

    getOpenaiResponseForHtml: {
        url: '/api/v1/report/get-openai-response-for-html',
        method: 'POST',
    },

    getInsightKey: {
        url: '/api/v1/report/get-insight-key',
        method: 'GET',
    },

    createNewCalibrationReport: {
        url: '/api/v1/meter/create-calibration-report',
        method: 'POST'
    },

    // Calibration Schedule
    createCalibrationSchedule: {
        url: '/api/v1/meter/calibration-schedule/create',
        method: 'POST'
    },
    getCalibrationSchedules: {
        url: '/api/v1/meter/calibration-schedule',
        method: 'GET'
    },
    updateCalibrationScheduleStatus: {
        url: '/api/v1/meter/calibration-schedule/update',
        method: 'POST'
    },
    deleteCalibrationSchedule: {
        url: '/api/v1/meter/calibration-schedule/delete',
        method: 'DELETE'
    },
    downloadCalibrationSchedules: {
        url: '/api/v1/meter/calibration-schedule/download',
        method: 'GET'
    },
    getLatestCalibrationDate: {
        url: '/api/v1/meter/calibration-schedule/latest-date',
        method: 'GET'
    },

    getCalibrationSchedulesCalendar: {
        url: '/api/v1/meter/calibration-schedule/calendar',
        method: 'GET'
    },

    //Tickets
    getAllTickets: {
        url: '/api/v1/client/get-all-tickets',
        method: 'GET'
    },
    getAllFacilityTickets: {
        url: '/api/v1/client/get-all-facility-tickets',
        method: 'GET'
    },
    getTicketById: {
        url: '/api/v1/client/get-ticket-by-id',
        method: 'GET'
    },
    getTicketsByAssignee: {
        url: '/api/v1/client/get-tickets-by-assignee',
        method: 'GET'
    },
    updateTicket: {
        url: '/api/v1/client/update-ticket',
        method: 'POST'
    },
    getAllAssignees: {
        url: '/api/v1/client/get-all-assignees',
        method: 'GET',
        storeKey: 'allAssignees'
    },
    getAllTicketStatus: {
        url: '/api/v1/client/get-all-status',
        method: 'GET',
        storeKey: 'allStatus'
    },
    addZohoProducts: {
        url: '/api/v1/client/add-zoho-products',
        method: 'GET',
    },
    getAllSiteVisitReport: {
        url: '/api/v1/project/get-all-site-visit-report',
        method: 'GET'
    },
    getSiteVisitReportById: {
        url: '/api/v1/project/get-site-visit-report-by-id',
        method: 'GET'
    },
    updateSiteVisitReport: {
        url: '/api/v1/project/update-site-visit-report',
        method: 'POST'
    },
    createNewSiteVisitReport: {
        url: '/api/v1/project/create-site-visit-report',
        method: 'POST'
    },
    getAllFacilitiesForTickets: {
        url: '/api/v1/facility/get-all-facilities-for-tickets',
        method: 'GET',
        storeKey: 'allFacilitiesForTickets'
    },
    deleteSiteVisitReport: {
        url: '/api/v1/project/delete-site-visit-report',
        method: 'DELETE'
    },
    deleteSiteVisitReportImage: {
        url: '/api/v1/project/delete-site-visit-report-image',
        method: 'DELETE'
    },

    deleteProjectImage: {
        url: '/api/v1/project/delete-project-image',
        method: "DELETE"
    },

    //Assets
    addNewClientAsset: {
        url: '/api/v1/asset/add-client-asset',
        method: 'POST'
    },

    getAllClientAssets: {
        url: '/api/v1/asset/get-all-client-assets',
        method: 'GET',
    },

    getAllAssets: {
        url: '/api/v1/asset/get-all-assets',
        method: 'GET',
    },

    getFacilityAssetsById: {
        url: '/api/v1/asset/get-facility-assets-by-id',
    },

    updateClientAsset: {
        url: '/api/v1/asset/update-client-asset',
        method: 'POST'
    },

    deleteClientAssets: {
        url: '/api/v1/asset/delete-client-assets',
        method: 'DELETE'
    },

    deleteAllFacilityAssets: {
        url: '/api/v1/asset/delete-all-facility-assets',
        method: 'DELETE'
    },

    getAllClientAssetCategories: {
        url: '/api/v1/asset/get-all-client-asset-categories',
        method: 'GET',
        storeKey: 'allClientAssetCategories'
    },

    createMaintenanceLog: {
        url: '/api/v1/asset/create-maintenance-log',
        method: 'POST'
    },

    getAllMaintenanceLogs: {
        url: '/api/v1/asset/get-all-maintenance-logs',
        method: 'GET',
    },

    getMaintenanceLogById: {
        url: '/api/v1/asset/get-maintenance-log-by-id',
    },

    updateMaintenanceLog: {
        url: '/api/v1/asset/update-maintenance-log',
        method: 'POST'
    },

    deleteMaintenanceMedia: {
        url: '/api/v1/asset/delete-maintenance-media',
        method: 'DELETE'
    },

    deleteClientAssetMedia: {
        url: '/api/v1/asset/delete-client-asset-media',
        method: 'DELETE'
    },

    getAllMaintenanceEngineers: {
        url: '/api/v1/asset/get-all-maintenance-engineers',
        method: 'GET',
        storeKey: 'allMaintenanceEngineers'
    },

    getAllMaintenanceApprovers: {
        url: '/api/v1/asset/get-all-maintenance-approvers',
        method: 'GET',
        storeKey: 'allMaintenanceApprovers'
    },

    getAllMaintenanceLogStatus: {
        url: '/api/v1/asset/get-all-maintenance-log-status',
        method: 'GET',
        storeKey: 'allMaintenanceLogStatus'
    },

    getAllAssetsLocationDetails: {
        url: '/api/v1/asset/get-all-assets-location-details',
        method: 'GET',
    },

    addNewComponent: {
        url: '/api/v1/asset/add-component',
        method: 'POST'
    },

    updateComponent: {
        url: '/api/v1/asset/update-component',
        method: 'POST'
    },

    getAllComponents: {
        url: '/api/v1/asset/get-all-components',
        method: 'GET'
    },

    getComponentById: {
        url: '/api/v1/asset/get-component-by-id',
    },

    getAssetMaintenanceSchedules: {
        url: '/api/v1/asset/get-asset-maintenance-schedules',
        method: 'GET'
    },

    getAllComponentsCategories: {
        url: '/api/v1/asset/get-all-components-categories',
        method: 'GET',
        storeKey: 'allComponentsCategories'
    },

    deleteComponent: {
        url: '/api/v1/asset/delete-component',
        method: 'DELETE'
    },

    getAssetMetersByPid: {
        url: '/api/v1/asset/get-all-asset-meters-by-pid',
        method: 'GET',
    },

    addNewAssetName: {
        url: '/api/v1/asset/add-asset-name',
        method: 'POST'
    },

    getAllAssetNames: {
        url: '/api/v1/asset/get-all-asset-names',
        method: 'GET'
    },

    getAssetNameById: {
        url: '/api/v1/asset/get-asset-name-by-id',
    },

    updateAssetName: {
        url: '/api/v1/asset/update-asset-name',
        method: 'POST'
    },

    deleteAssetName: {
        url: '/api/v1/asset/delete-asset-name',
        method: 'DELETE'
    },

    addInventoryItems: {
        url: '/api/v1/asset/add-inventory-items',
        method: 'POST'
    },

    getAllInventoryItems: {
        url: '/api/v1/asset/get-all-inventory-items',
        method: 'GET'
    },

    getInventoryItemById: {
        url: '/api/v1/asset/get-inventory-item-by-id',
    },

    updateInventoryItem: {
        url: '/api/v1/asset/update-inventory-item',
        method: 'POST'
    },

    deleteInventoryItem: {
        url: '/api/v1/asset/delete-inventory-item',
        method: 'DELETE'
    },

    getSTPOpexCostIndexQueryData: {
        url: '/api/v1/report/get-stp-opex-cost-index-query-data',
        method: 'GET'
    },

    getSTPEnergyIndexQueryData: {
        url: '/api/v1/report/get-stp-energy-index-query-data',
        method: 'GET'
    },

    getETPWaterBalanceQueryData: {
        url: '/api/v1/report/get-etp-water-balance-query-data',
        method: 'GET'
    },

    getETPEnergyIndexQueryData: {
        url: '/api/v1/report/get-etp-energy-index-query-data',
        method: 'GET'
    },

    getETPOpexCostIndexQueryData: {
        url: '/api/v1/report/get-etp-opex-cost-index-query-data',
        method: 'GET'
    },

    getROWaterBalanceQueryData: {
        url: '/api/v1/report/get-ro-water-balance-query-data',
        method: 'GET'
    },

    getWTPWaterBalanceQueryData: {
        url: '/api/v1/report/get-wtp-water-balance-query-data',
        method: 'GET'
    },

    getWTPEnergyIndexQueryData: {
        url: '/api/v1/report/get-wtp-energy-index-query-data',
        method: 'GET'
    },

    getSTPWaterBalanceQueryData: {
        url: '/api/v1/report/get-stp-water-balance-query-data',
        method: 'GET'
    },

    getWTPWaterQualityParamIndexQueryData: {
        url: '/api/v1/report/get-wtp-water-quality-param-index-query-data',
        method: 'GET'
    },

    getSTPWaterQualityParamIndexQueryData: {
        url: '/api/v1/report/get-stp-water-quality-param-index-query-data',
        method: 'GET'
    },

    getWaterBalanceData: {
        url: '/api/v1/report/get-water-balance-data',
        method: 'GET'
    },

    getWaterUsageData: {
        url: '/api/v1/report/get-water-usage-data',
        method: 'GET'
    },

    // Announcements Module
    sendAnnouncement: {
        url: '/api/v1/announcements',
        method: 'POST'
    },

    getAllAnnouncementClients: {
        url: '/api/v1/announcements/clients',
        method: 'GET'
    },

    // Business Dashboard
    getBusinessDashboard: {
        url: '/api/v1/client/get-business-dashboard',
        method: 'GET'
    },
    refreshBusinessDashboardCache: {
        url: '/api/v1/client/refresh-business-dashboard-cache',
        method: 'POST'
    },
    downloadBusinessDashboard: {
        url: '/api/v1/client/download-business-dashboard',
        method: 'GET'
    },
    getInvoiceSchedule: {
        url: '/api/v1/client/invoice-schedule',
        method: 'GET'
    },
    getRenewalDashboard: {
        url: '/api/v1/client/renewal-dashboard',
        method: 'GET'
    },
    getRenewalComments: {
        url: '/api/v1/client/renewal-comments',
        method: 'GET'
    },
    addRenewalComment: {
        url: '/api/v1/client/renewal-comments',
        method: 'POST'
    },

    // Opportunities
    createOpportunity: {
        url: '/api/v1/opportunities/create',
        method: 'POST'
    },
    getOpportunityById: {
        url: '/api/v1/opportunities/get-opportunity',
        method: 'GET'
    },
    getOpportunitiesByClient: {
        url: '/api/v1/opportunities/get-all-opportunities',
        method: 'GET'
    },
    getOpportunityDashboard: {
        url: '/api/v1/opportunities/dashboard',
        method: 'GET'
    },
    updateOpportunity: {
        url: '/api/v1/opportunities/update',
        method: 'PUT'
    },
    deleteOpportunity: {
        url: '/api/v1/opportunities/delete',
        method: 'DELETE'
    },
    uploadOpportunityAttachment: {
        url: '/api/v1/opportunities/upload-attachment',
        method: 'POST'
    },
    deleteOpportunityAttachment: {
        url: '/api/v1/opportunities/delete-attachment',
        method: 'DELETE'
    },
    downloadOpportunityAttachment: {
        url: '/api/v1/opportunities/download-attachment',
        method: 'GET'
    },
    getOpportunityTags: {
        url: '/api/v1/opportunities/tags',
        method: 'GET'
    },
    createOpportunityTag: {
        url: '/api/v1/opportunities/tags',
        method: 'POST'
    },

    // Opportunity Schedules
    createOpportunitySchedule: {
        url: '/api/v1/opportunities/schedules/create',
        method: 'POST'
    },
    getOpportunitySchedulesCalendar: {
        url: '/api/v1/opportunities/schedules/calendar',
        method: 'GET'
    },
    getOpportunitySchedulesByClient: {
        url: '/api/v1/opportunities/schedules',
        method: 'GET'
    },
    updateOpportunitySchedule: {
        url: '/api/v1/opportunities/schedules/update',
        method: 'PUT'
    },
    deleteOpportunitySchedule: {
        url: '/api/v1/opportunities/schedules/delete',
        method: 'DELETE'
    },
    // Leads
    createLead: {
        url: '/api/v1/leads/create',
        method: 'POST'
    },
    getLeadById: {
        url: '/api/v1/leads/get-lead',
        method: 'GET'
    },
    getLeadDashboard: {
        url: '/api/v1/leads/dashboard',
        method: 'GET'
    },
    updateLead: {
        url: '/api/v1/leads/update',
        method: 'PUT'
    },
    deleteLead: {
        url: '/api/v1/leads/delete',
        method: 'DELETE'
    },
    getLeadTags: {
        url: '/api/v1/leads/tags',
        method: 'GET'
    },

    // Lead Schedules
    createLeadSchedule: {
        url: '/api/v1/leads/schedules/create',
        method: 'POST'
    },
    getLeadSchedulesCalendar: {
        url: '/api/v1/leads/schedules/calendar',
        method: 'GET'
    },
    getLeadSchedulesDashboard: {
        url: '/api/v1/leads/schedules/dashboard',
        method: 'GET'
    },
    getLeadScheduleById: {
        url: '/api/v1/leads/schedules/detail',
        method: 'GET'
    },
    updateLeadSchedule: {
        url: '/api/v1/leads/schedules/update',
        method: 'PUT'
    },
    deleteLeadSchedule: {
        url: '/api/v1/leads/schedules/delete',
        method: 'DELETE'
    },

    // Facility Project Management
    getProjectSubTasksCalendar: {
        url: '/api/v1/client-projects/calendar',
        method: 'GET'
    },
    getTicketsCalendar: {
        url: '/api/v1/client/tickets-calendar',
        method: 'GET'
    },
    getFacilityProjectsByClient: {
        url: '/api/v1/client-projects/client',
        method: 'GET'
    },
    createFacilityProject: {
        url: '/api/v1/client-projects/create',
        method: 'POST'
    },
    getFacilityProjectById: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    updateFacilityProject: {
        url: '/api/v1/client-projects/update',
        method: 'PUT'
    },
    deleteFacilityProject: {
        url: '/api/v1/client-projects/delete',
        method: 'DELETE'
    },
    uploadFacilityProjectAttachment: {
        url: '/api/v1/client-projects/upload-attachment',
        method: 'POST'
    },
    deleteFacilityProjectAttachment: {
        url: '/api/v1/client-projects/delete-attachment',
        method: 'DELETE'
    },
    downloadFacilityProjectAttachment: {
        url: '/api/v1/client-projects/download-attachment',
        method: 'GET'
    },
    getFacilityProjectDashboard: {
        url: '/api/v1/client-projects/dashboard',
        method: 'GET'
    },
    getProjectTaskTags: {
        url: '/api/v1/client-projects/task-tags',
        method: 'GET'
    },
    getProjectTimelines: {
        url: '/api/v1/client-projects/timelines',
        method: 'GET'
    },
    getProjectSchedule: {
        url: '/api/v1/client-projects/schedule',
        method: 'GET'
    },
    getMonthSiteVisits: {
        url: '/api/v1/client-projects/visits/month',
        method: 'GET'
    },
    getSubTaskSiteVisits: {
        url: '/api/v1/client-projects/visits/sub-task',
        method: 'GET'
    },
    checkInSubTask: {
        url: '/api/v1/client-projects/visits/check-in',
        method: 'POST'
    },
    uploadSiteVisitPhoto: {
        url: '/api/v1/client-projects/visits',
        method: 'POST'
    },
    deleteSiteVisitPhoto: {
        url: '/api/v1/client-projects/visits/photos',
        method: 'DELETE'
    },
    checkOutSiteVisit: {
        url: '/api/v1/client-projects/visits',
        method: 'PUT'
    },
    updateSubTaskStatus: {
        url: '/api/v1/client-projects/sub-task',
        method: 'PUT'
    },
    getProjectEditor: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    createProjectFromEditor: {
        url: '/api/v1/client-projects/editor/create',
        method: 'POST'
    },
    saveProjectEditor: {
        url: '/api/v1/client-projects',
        method: 'PUT'
    },
    getClientFacilityProject: {
        url: '/api/v1/client-projects/client-view/facility',
        method: 'GET'
    },
    getClientSubTaskVisits: {
        url: '/api/v1/client-projects/client-view/sub-task',
        method: 'GET'
    },
    requestVisitDateChange: {
        url: '/api/v1/client-projects/client-view/sub-task',
        method: 'POST'
    },
    getPendingDateRequests: {
        url: '/api/v1/client-projects/date-requests/pending',
        method: 'GET'
    },
    approveDateRequest: {
        url: '/api/v1/client-projects/date-requests',
        method: 'PUT'
    },
    declineDateRequest: {
        url: '/api/v1/client-projects/date-requests',
        method: 'PUT'
    },
    getProjectPlan: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    getProjectPlanReport: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    getProjectTickets: {
        url: '/api/v1/client-projects/tickets/list',
        method: 'GET'
    },
    scheduleProjectTicket: {
        url: '/api/v1/client-projects/tickets',
        method: 'PUT'
    },
    resolveProjectTicket: {
        url: '/api/v1/client-projects/tickets',
        method: 'PUT'
    },
    raiseProjectTicket: {
        url: '/api/v1/client-projects/tickets/facility',
        method: 'POST'
    },
    getTicketSiteVisits: {
        url: '/api/v1/client-projects/visits/ticket',
        method: 'GET'
    },
    checkInTicket: {
        url: '/api/v1/client-projects/visits/check-in/ticket',
        method: 'POST'
    },
    getClientProjectPlan: {
        url: '/api/v1/client-projects/client-view/project',
        method: 'GET'
    },
    getClientProjectPlanReport: {
        url: '/api/v1/client-projects/client-view/project',
        method: 'GET'
    },
    getClientFacilityTickets: {
        url: '/api/v1/client-projects/client-view/facility',
        method: 'GET'
    },
    raiseClientTicket: {
        url: '/api/v1/client-projects/client-view/facility',
        method: 'POST'
    },
    getProjectBudgets: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    createProjectBudget: {
        url: '/api/v1/client-projects',
        method: 'POST'
    },
    getProjectBudget: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    saveProjectBudget: {
        url: '/api/v1/client-projects',
        method: 'PUT'
    },
    deleteProjectBudget: {
        url: '/api/v1/client-projects',
        method: 'DELETE'
    },
    exportProjectBudget: {
        url: '/api/v1/client-projects',
        method: 'POST'
    },
    getProjectBudgetExports: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
    downloadProjectBudgetExport: {
        url: '/api/v1/client-projects',
        method: 'GET'
    },
}